/*
 * The portal's modules and the role a person has in each (docs/API.md → Enums, Permissions).
 * A module missing from a person's `modules` is switched off for them: its endpoints answer 403
 * and the console hides it. Being a portal administrator is a separate flag (`portal_admin`) —
 * it runs users and settings and grants nothing inside a module.
 */
export enum Module {
    Naloge = 'naloge',
}

/** The modules in the order the menu and every list of them show them. */
export const MODULES: Module[] = [Module.Naloge]

export enum ModuleRole {
    Manager = 'manager',
    Member  = 'member',
}
